import { useQuery } from '@tanstack/react-query';

import { getLineFriend } from 'api/line';
import { queryKeys } from 'constants/queryKeys';
import { userStrings } from 'constants/strings';
import { useAuth } from 'contexts/AuthContext';
import { toErrorMessage } from 'hooks/utils';
import type { TLineFriendDetail } from 'types';

type UseLineFriendResult = {
  friend: TLineFriendDetail | undefined;
  loading: boolean;
  error: string | undefined;
};

export function useLineFriend(userLineId?: number): UseLineFriendResult {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: [queryKeys.LINE_FRIEND_DETAIL, userLineId, user?.uid],
    enabled: Boolean(user?.uid && userLineId !== undefined),
    queryFn: () => {
      if (userLineId === undefined) {
        throw new Error(userStrings.edit.errors.loadFailed);
      }
      return getLineFriend(userLineId);
    },
    retry: false,
  });

  return {
    friend: query.data,
    loading: Boolean(user?.uid && userLineId !== undefined) && query.isPending,
    error: query.error
      ? toErrorMessage(query.error, userStrings.edit.errors.loadFailed)
      : undefined,
  };
}
